export const Register_Section = 'Register_Section'
export const Logout = 'Logout'
export const Hotels='Hotels'
export const SelectedHotel='SelectedHotel'